import api from "./Api";

class SessaoUsuarioConnectionService {
  GetSessaoUsuarioConnection(payload) {
    return api
      .get("/v1/sessaoUsuarioConnection/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  PostSessaoUsuarioConnection(payload) {
    return api
      .post("/v1/sessaoUsuarioConnection/", payload)
      .then((response) => {
        return response.data;
      });
  }

  PutSessaoUsuarioConnection(payload) {
    return api.put("/v1/sessaoUsuarioConnection/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteSessaoUsuarioConnection(payload) {
    return api
      .delete("/v1/sessaoUsuarioConnection/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetSessaoUsuarioConnectionOData(payload) {
    return api
      .get("/OData/SessaoUsuarioConnection" + payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new SessaoUsuarioConnectionService();
